


import React, { useEffect } from 'react';
import ProBg from "./proBg.jpg"

const MsChannel = () => {
    useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when this page loads
  }, []);
  return (
    <div>
      <section
        className="featured-job-area section-padding30 section-bg2"
        style={{
        backgroundImage: `url(${ProBg})`,  backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '400px',  // Adjust the height here
        }}
      >
        <div className="container">
          <div className="row justify-content">
            <div className="col-xl-7 col-lg-9 col-md-10 col-sm-12">
              {/* Section Title */}
              <div className="section-tittle text-left mb-80">
                <h2>Cold Rolled Coils & Sheets</h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            {/* Add content here */}
          </div>
        </div>
      </section>

      <section className="about-low-area section-padding2" style={{ marginTop: '-50px' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-10">
              <div className="about-caption mb-11">
                <div className="section-tittle mb-11">
                  {/* <span>About Al Hadeed Steel</span> */}
                  {/* <h2>Building the Future with Strength and Durability</h2> */}
                </div>
                <p style={{lineHeight:"2.4"}}>

<h3>Mild Steel (MS) Channel</h3>
<p>Also known as <strong>C-Channel</strong>, <strong>Structural Channel</strong>, or <strong>Rolled Steel Channel (RSC)</strong>, MS Channels are structural components widely recognized for their versatility and strength. These channels have a "C" shape with a vertical web and horizontal flanges, making them ideal for carrying both horizontal and vertical loads.</p>

<h3>Applications</h3>
<p>Renowned for their <strong>robust design</strong>, <strong>easy machinability</strong>, and <strong>durability</strong>, MS Channels are extensively used in various industries, such as:</p>
<ul>
  <li><strong>Construction</strong>: Ideal for structural frameworks, bridges, factory sheds, and multi-story buildings.</li>
  <li><strong>Automotive and Transportation</strong>: Used in manufacturing truck trailers, tippers, and bus bodies.</li>
  <li><strong>Cranes and Material Handling</strong>: Frames for EOT (Electric Overhead Travelling) cranes, conveyors, and mechanized parking systems.</li>
  <li><strong>Shipbuilding and Marine Applications</strong>: Providing structural support for ship hulls and frames.</li>
  <li><strong>Agriculture</strong>: Essential in equipment like plows, tractors, and irrigation systems.</li>
  <li><strong>Engineering and Fabrication</strong>: Frames for generators, boilers, cable trays, and machinery support.</li>
</ul>

<h3>Features and Benefits</h3>
<ul>
  <li><strong>Strength and Versatility</strong>: Capable of withstanding heavy loads, both compressive and tensile.</li>
  <li><strong>Cost-Efficiency</strong>: Provides a high strength-to-weight ratio, reducing material and transportation costs.</li>
  <li><strong>Customizable</strong>: Available in various sizes and lengths, they can be tailored to suit specific project requirements.</li>
  <li><strong>Corrosion Resistance</strong>: Can be galvanized or coated for enhanced durability in harsh environments.</li>
</ul>

<h3>Common Synonyms</h3>
<p>Other terms for MS Channel include:</p>
<ul>
  <li><strong>C-Beam</strong></li>
  <li><strong>Channel Bar</strong></li>
  <li><strong>Structural Channel</strong></li>
  <li><strong>Parallel Flange Channel (PFC)</strong></li>
  <li><strong>Steel Channel Section</strong></li>
</ul>

 </p>
                
              </div>
            </div>
          </div>
        
        </div>
      </section>
    </div>
  );
}

export default MsChannel;
